export default {
  init() {
  },
  finalize() {
    // 記事中のYouTube動画にrelが未設定の場合はrel=0（関連動画の非表示）を付与。
    $('article iframe').each(function () {
      const me = $(this);
      const src = me.attr('src');
      if (/(youtube\.com)/.test(src)) {
        const srcUrl = new URL(src);
        if (!srcUrl.searchParams.has('rel')) {
          srcUrl.searchParams.set('rel', 0);
          console.log('Added "rel=0" for YouTube iframe in article');
          me.attr('src', srcUrl.toString());
        }
      }
    });

    // リサイズ処理
    const resizeIframeWithKeepingAspectRatio = function () {
      $('article iframe').each(function () {
        const me = $(this);
        if (/(youtube\.com|vimeo\.com)/.test(me.attr('src'))) {
          const height = me.width() * (me.attr('height') / me.attr('width'));
          me.css('height', `${height}px`);
        }
      });
    };
    $(window).on('resize', resizeIframeWithKeepingAspectRatio);
    resizeIframeWithKeepingAspectRatio();
  }
};
